import {nanoid} from 'nanoid';
import {RatingError} from './types';

export const handleQuoteRatingAPIErrors = (errorResponse: any) => {
  if (Array.isArray(errorResponse.errors)) {
    return errorResponse.errors?.reduce(
      (acc: Record<string, any>, error: RatingError) => ({
        ...acc,
        [`${error?.details?.entityName}.${error?.details?.fieldName}`]: error.message,
      }),
      {}
    );
  }

  if (errorResponse?.message) {
    return {[nanoid()]: errorResponse.message};
  }
  return {}
};
